export default "__VITE_ASSET__2d35044c__"